import { render, staticRenderFns } from "./PartValveServiceQueueList.vue?vue&type=template&id=2c07498e&scoped=true"
import script from "./PartValveServiceQueueList.vue?vue&type=script&lang=js"
export * from "./PartValveServiceQueueList.vue?vue&type=script&lang=js"
import style0 from "./PartValveServiceQueueList.vue?vue&type=style&index=0&id=2c07498e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c07498e",
  null
  
)

export default component.exports